import Luminous, { LuminousGallery } from 'luminous-lightbox';
import Swiper from 'swiper';

import GLightbox from 'glightbox';
import 'glightbox/dist/css/glightbox.css';

export default class Property {
    constructor() {
        this.detailSlider();
        this.readmore();
        this.luminous();
    }

    detailSlider() {
        const propertySliderEl = document.querySelector('#property #property-slider');
        if (!propertySliderEl) return;

        this.swiperMain = new Swiper('#property-slider.main-slider', {
            navigation: {
                nextEl: '#property-slider .swiper-button-next',
                prevEl: '#property-slider .swiper-button-prev',
            },
            loop: false,
        });

        this.slideImages = Array.from(
            document.querySelectorAll('#property-slider .swiper-slide img')
        );

        const galleryElements = this.slideImages.map((imgEl) => ({
            href: imgEl.src,
            type: 'image',
        }));
        this.lightbox = GLightbox({
            elements: galleryElements,
            loop: true,
            touchNavigation: true,
        });

        this.thumbsContainer = document.getElementById('property-thumbs');
        if (!this.thumbsContainer) return;

        this.renderThumbs = () => {
            this.thumbsContainer.innerHTML = '';

            const max = this.getMaxThumbs();
            const total = this.slideImages.length;

            if (total <= max) {
                this.slideImages.forEach((imgEl, idx) => {
                    this.thumbsContainer.appendChild(
                        this.createThumbElement(imgEl, idx, false, 0)
                    );
                });
            } else {
                const normalCount = max - 1;
                for (let i = 0; i < normalCount; i++) {
                    this.thumbsContainer.appendChild(
                        this.createThumbElement(this.slideImages[i], i, false, 0)
                    );
                }
                const remaining = total - normalCount;
                this.thumbsContainer.appendChild(
                    this.createThumbElement(this.slideImages[normalCount], normalCount, true, remaining)
                );
            }
        };

        this.renderThumbs();

        window.addEventListener('resize', () => {
            this.renderThumbs();
        });
    }

    getMaxThumbs() {
        if (window.innerWidth >= 1200) return 5;
        if (window.innerWidth >= 768) return 4;
        if (window.innerWidth >= 552) return 3;
        return 3;
    }

    createThumbElement(imgEl, index, blurred, remaining) {
        const thumbDiv = document.createElement('div');
        thumbDiv.classList.add('thumb-slide');
        if (blurred) thumbDiv.classList.add('blurred-thumb');

        const thumbSrc = imgEl.dataset.thumbSrc || imgEl.src;

        // <img> inside thumbnail
        const thumbImg = document.createElement('img');
        thumbImg.src = thumbSrc;
        thumbDiv.appendChild(thumbImg);

        if (blurred) {
            // +X overlay
            const overlay = document.createElement('div');
            overlay.className = 'thumb-overlay';
            overlay.innerHTML = `<span>+${remaining}</span>`;
            thumbDiv.appendChild(overlay);

            // Clicking => open GLightbox at the "first hidden" index
            thumbDiv.addEventListener('click', () => {
                this.lightbox.openAt(index);
            });
        } else {
            // Normal => jump main slider
            thumbDiv.addEventListener('click', () => {
                this.swiperMain.slideTo(index);
            });
        }

        return thumbDiv;
    }

    readmore() {
        if (document.querySelector('#property') || document.querySelector('#project')) {
            const text = document.querySelector('#omschrijving .text');
            if (!text) return;

            const height = text.offsetHeight;
            const readmore = document.querySelector('#omschrijving .read-more');
            if (!readmore) return;

            text.style.height = '280px';

            readmore.addEventListener('click', (ev) => {
                ev.preventDefault();
                text.style.height = height + 'px';
                readmore.style.display = 'none';
            });
        }
    }

    luminous() {
        new LuminousGallery(document.querySelectorAll('#fotos .foto .luminous'));
        new LuminousGallery(document.querySelectorAll('#plattegronden .foto .luminous'));
    }
}
